export const fakeClientCards = [
  'card 1',
  'card 2',
  'card 3',
  'card 4',
  'card 5',
  'card 6'
];
